// extracted by mini-css-extract-plugin
module.exports = {"page":"Home_page__39vNC","header":"Home_header__1R0NL"};